import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ImportsModule } from "src/app/modules/shared/imports/imports.module";
import { AcuerdoPagoRoutingModule } from "./acuerdo-pago-routing.module";
import { AcuerdoPagoComponent } from "./components/acuerdo-pago/acuerdo-pago.component";
import { AcuerdoPagoService } from "./components/services/acuerdo-pago.service";

@NgModule({
    declarations: [
        AcuerdoPagoComponent
    ],
    providers: [AcuerdoPagoService],
    imports: [
      CommonModule,
      ImportsModule,
      AcuerdoPagoRoutingModule,
    ],
  })
  export class AcuerdoPagoModule { }